import request from '@/utils/request'
import { getShopId } from '@/api/shop/shopApi'

/**
 * 查询文档列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function getSysDocumentList(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sysDocument/querySysDocument',
      method: 'get',
      params: {
        ...params,
        shopId: getShopId()
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存文档
 * @param {Object} data 文档数据
 * @returns {Promise} Promise对象
 */
export function saveSysDocument(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sysDocument/saveSysDocument',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 更新文档
 * @param {Object} data 文档数据
 * @returns {Promise} Promise对象
 */
export function updateSysDocument(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sysDocument/updateSysDocument',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除文档
 * @param {Object} data 文档数据
 * @returns {Promise} Promise对象
 */
export function deleteSysDocument(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/sysDocument/deleteSysDocument',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}